import { render, staticRenderFns } from "./SelectNotetakingGuide.vue?vue&type=template&id=170255a1&scoped=true"
import script from "./SelectNotetakingGuide.vue?vue&type=script&lang=js"
export * from "./SelectNotetakingGuide.vue?vue&type=script&lang=js"
import style0 from "./SelectNotetakingGuide.vue?vue&type=style&index=0&id=170255a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170255a1",
  null
  
)

export default component.exports